import { FC } from 'react';
import DoctorDropdown from './DoctorDropdown';

interface OutOfNetworkDoctorDropdownProps {
  insuranceId: string;
  selectedDoctorIds: string[];
  disabledDoctorIds: string[];
  disabled?: boolean;
}

const OutOfNetworkDoctorDropdown: FC<OutOfNetworkDoctorDropdownProps> = ({
  insuranceId,
  selectedDoctorIds,
  disabledDoctorIds,
  disabled,
}) => {
  return (
    <DoctorDropdown
      insuranceId={insuranceId}
      selectedDoctorIds={selectedDoctorIds}
      isInNetwork={false}
      disabledDoctorIds={disabledDoctorIds}
      disabled={disabled}
    />
  );
};

export default OutOfNetworkDoctorDropdown;